'use client'

import { FC, ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'

const Overlay = styled.div<{ $isOpen: boolean; $bgColor: string; $padding: string; $gap: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ $bgColor }) => $bgColor};
  z-index: 1200;
  transform: ${({ $isOpen }) => ($isOpen ? 'translateY(0)' : 'translateY(-100%)')};
  transition: transform 0.3s ease;
  padding: ${({ $padding }) => $padding};
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap}px;
  overflow-y: auto;
  box-sizing: border-box;
`

type SlideDownModalProps = {
  isOpen: boolean
  onClose?: () => void
  children: ReactNode
  bgColor?: string
  padding?: string
  gap?: number
}

export const SlideDownModal: FC<SlideDownModalProps> = ({
  isOpen,
  children,
  bgColor = '#fff',
  padding = '20px 16px 28px',
  gap = 20,
}) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted) return
    document.body.style.overflow = isOpen ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen, mounted])

  if (!mounted) return null

  return createPortal(
    <Overlay $isOpen={isOpen} $bgColor={bgColor} $padding={padding} $gap={gap}>
      {children}
    </Overlay>,
    document.body
  )
}
